import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { deprecateFn } from '../internals/utils';

const loader = (newLoadingStyle, loadingText) =>
  newLoadingStyle ? (
    <div className='btn__loading'>{loadingText}</div>
  ) : (
    <span>
      <div className='bounce bounce1' />
      <div className='bounce bounce2' />
      <div className='bounce bounce3' />
    </span>
  );

export const DEPRECATED_VARIANT_CLASSES = {
  primary: 'btn--primary',
  secondary: 'btn--secondary',
  tertiary: 'btn--tertiary'
};

export const VARIANT_CLASSES = {
  primary: '-primary',
  secondary: '-secondary',
  tertiary: '-tertiary'
};

const Button = ({
  children,
  element: Element,
  type,
  variant,
  outline,
  wide,
  loading,
  disabled,
  invert,
  onClick,
  className: classes,
  newLoadingStyle,
  loadingText,
  ...props
}) => {
  const buttonPropsDeprecation = deprecateFn();
  buttonPropsDeprecation(
    !newLoadingStyle || newLoadingStyle,
    'The newLoadingStyle prop and support for old styleguide buttons will be deprecated on version 4.x.'
  );
  const newClassNames = classNames(
    classes,
    'btn',
    {
      'btn--loader -loading': loading,
      '-inactive': disabled,
      '-wide': wide,
      '-inverted': invert
    },
    VARIANT_CLASSES[variant]
  );

  const deprecatedClassNames = classNames(
    classes,
    'btn',
    DEPRECATED_VARIANT_CLASSES[variant],
    {
      'btn--loading': loading,
      'btn--disabled': disabled,
      'btn--outline': outline && !loading,
      'btn--wide': wide,
      'btn--invert': invert
    }
  );

  const generatedClassName = newLoadingStyle
    ? newClassNames
    : deprecatedClassNames;

  if (disabled || loading) {
    return (
      <Element
        disabled={disabled}
        type={Element === 'button' ? 'button' : type}
        className={generatedClassName}
        {...props}
      >
        <div className={loading ? 'btn__loader-container' : ''}>
          {loading ? loader(newLoadingStyle, loadingText) : children}
        </div>
      </Element>
    );
  }

  return (
    <Element
      type={type}
      className={generatedClassName}
      onClick={onClick}
      {...props}
    >
      {children}
    </Element>
  );
};

Button.defaultProps = {
  element: 'button',
  variant: 'primary'
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  element: PropTypes.string,
  invert: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  outline: PropTypes.bool,
  type: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', undefined]),
  wide: PropTypes.bool,
  newLoadingStyle: PropTypes.bool,
  loadingText: PropTypes.string
};

export default Button;
